import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { childrenPropType } from "components/propTypes";
import InputsLabel from "./input-label";

const propTypes = {
  additionalClassName: PropTypes.string,
  children: childrenPropType, // when using InputContainer, wrap it around the input you want
  isInlineInput: PropTypes.bool,
  labelProps: PropTypes.shape({
    additionalClassName: PropTypes.object,
    headerText: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    subHeaderText: PropTypes.string,
  }),
};

const InputContainer = ({ additionalClassName, children, isInlineInput = false, labelProps = {} }) => {
  const containerClassName = classNames("flex flex-col gap-2 pb-6", additionalClassName, {
    "flex-row items-center": isInlineInput,
  });

  return (
    <div className={containerClassName}>
      <InputsLabel
        additionalClassName={labelProps.additionalClassName}
        headerText={labelProps.headerText || ""}
        isRequired={labelProps.isRequired}
        subHeaderText={labelProps.subHeaderText}
      />
      {children}
    </div>
  );
};

InputContainer.propTypes = propTypes;
export default InputContainer;
